import User from '@decisiv/iconix/lib/components/User';

/**
 * LeftNav items for the Management tool.
 *
 * PD-4215 scopes this to User Management only — app/module navigation is
 * explicitly out of scope — so there is a single entry for now. Add siblings
 * here as the tool grows; KeyDS renders a nested `items` array as a submenu.
 */
const NAV_ITEMS = [
  {
    icon: User,
    text: 'Users',
    path: '/management/users',
  },
];

export default NAV_ITEMS;
